import { useMemo } from 'react';

interface TextTruncateProps {
  text: string;
  limit?: number;
  ellipsis?: string;
  style?: React.CSSProperties;
}

const TextTruncate = ({ text, limit = 50, ellipsis = '...', style }: TextTruncateProps) => {
  const ellipsisStr = useMemo(() => {
    if (text.length > limit) {
      return text.substring(0, limit) + ellipsis || '...';
    }
    return text;
  }, [text, ellipsis, limit]);

  return (
    <span style={style} title={text}>
      {ellipsisStr}
    </span>
  );
};

export default TextTruncate;
